import { render, staticRenderFns } from "./CustomerSessionTable.vue?vue&type=template&id=5313807e&scoped=true"
import script from "./CustomerSessionTable.vue?vue&type=script&lang=ts"
export * from "./CustomerSessionTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomerSessionTable.vue?vue&type=style&index=0&id=5313807e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313807e",
  null
  
)

export default component.exports